import {useCallback, useRef} from 'react';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const useCallbackWithRef = <F extends (...args: any[]) => any>(func: F): F => {
    const funcRef = useRef(func);
    funcRef.current = func;


    return useCallback(((...args: Parameters<F>) => funcRef.current(...args)) as F, []);
};
